import defaultPostTypeConfig from '../post'
import capitalize from '../../utils/capitalize'

export default function getConstants(p = {}) {

    const name = 'chat'

    const n = name
    const N = capitalize(n)
    const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'
    const Ns = capitalize(ns)

    // The chat agent's display name — the SINGLE place to change it on the web (no separate config needed).
    const agentName = 'Viktória'

    const {
        labels,
        menus,
        messages,
        routes,
        titles
    } = defaultPostTypeConfig.getConstants({
        ...p,
        name
    })

    return {
        labels: {
            ...labels,
            ['new' + N + 'SubmitLabel']: 'Küldés',
            ['restore' + N + 'SubmitLabel']: 'Visszaállítás',
            ['save' + N + 'SubmitLabel']: 'Küldés',
            ['cancel' + N + 'Text']: 'Mégsem',
            ['delete' + N + 'Text']: 'Törlés',
            ['delete' + Ns + 'Text']: 'Beszélgetések törlése',
            ['ban' + N + 'Text']: 'Tiltás',
            ['approve' + N + 'Text']: 'Jóváhagyás',
            ['protection' + N + 'Text']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Text']: 'Védettség megszüntetése',
            ['select' + N + 'Text']: 'Kiválasztás',
            ['add' + N + 'Text']: 'Hozzáadás',
            ['moreFromMy' + Ns + 'Title']: 'További beszélgetéseim',
            ['moreFromUser' + Ns + 'Title']: 'További beszélgetések',
            [n + 'ContactBox']: 'További közösségi oldalak',
            [n + 'OpenContactBox']: 'Szerkesztés',

            [ns + 'SortRelevance']: 'Relevancia',
            [n + 'NewTryAgain']: 'Újra',

            [n + 'Connection']: 'Kapcsolódás',
            [n + 'SocketServerDisconnected']: 'A szerver kapcsolat bezárt',
            [n + 'SocketServerTryAgain']: 'Újra kapcsolódás',

            [n + 'ApprovalTitle']: 'Jóváhagyás kell',
            [n + 'ApprovalAllow']: 'Engedélyezem',
            [n + 'ApprovalDeny']: 'Most nem',
            [n + 'ApprovalFitText']: agentName + ' felhasználhatja a munkavállalói profilodat és az önéletrajzodat, hogy a hozzád leginkább illő állásokat keresse. Engedélyezed?',
            //[n + 'ApprovalJobFitText']: agentName + ' felhasználhatja a munkavállalói profilodat és az önéletrajzodat, hogy megmutassa, mennyire illik hozzád ez az állás. Engedélyezed?',
            [n + 'ApprovalJobFitText']: 'Engedélyezed, hogy ' + agentName + ' a munkavállalói profilod és az önéletrajzod alapján felmérje, mennyire felel meg számodra ez az álláslehetőség?',
            [n + 'ApprovalAnalyzeText']: 'Feldolgozzuk az önéletrajzodat és a munkavállalói profilodat, hogy a hozzád illő állásokat sorba tudjuk rendezni. Engedélyezed?',
            [n + 'ApprovalProfilePictureText']: 'Beállítjuk a kiválasztott képet profilképnek. Engedélyezed?',
            [n + 'ApprovalApplyText']: ({ jobs } = {}) => {
                const list = Array.isArray(jobs) ? jobs : []
                const count = list.length
                const intro = count > 1
                    ? ('Beadjuk a jelentkezésed ' + count + ' állásra a profilod adataival. ')
                    : (list[0]?.jobTitle
                        ? 'Beadjuk a jelentkezésed a(z) „' + list[0].jobTitle + '" állásra a profilod adataival. '
                        : 'Beadjuk a jelentkezésed erre az állásra a profilod adataival. ')
                return intro
                    + 'A jelentkezés elküldésével a feltöltött önéletrajzodat elérhetővé tesszük a hirdetés '
                    + 'feladójának, illetve kiadhatjuk az oldalon kereső munkaadóknak. A jelentkezéssel elfogadod '
                    + 'a feltételeket. Engedélyezed?'
            },
            [n + 'ApplySuccessNotice']: ({ jobTitle } = {}) => (jobTitle
                ? 'Sikeresen jelentkeztél a(z) „' + jobTitle + '" című hirdetésre.'
                : 'Sikeresen beadtuk a jelentkezésed.'),
            [n + 'PostAsMain']: agentName,
            [n + 'Working']: agentName + ' dolgozik a válaszon…',

            [n + 'Stop']: 'Stop',
            [n + 'AgentStop']: 'Leállítás',
            [n + 'AgentsEmpty']: 'Nincs futó ügynök.',
            [n + 'AgentsNew']: 'Új',

            [n + 'Attach']: 'Fájl csatolása',
            [n + 'AttachUploading']: 'Feltöltés…',
            [n + 'AttachDone']: 'Feltöltöttem egy fájlt.',
            [n + 'AttachDoneMany']: 'Feltöltöttem néhány fájlt.',

            [n + 'ActionMenu']: 'Műveletek',
            [n + 'ActionPersonalizedSearch']: 'Személyre szabott keresés',
            [n + 'ActionSetProfilePicture']: 'Profilkép beállítása',
            [n + 'PickCvTitle']: 'Válaszd ki az önéletrajzod, vagy tölts fel újat',
            [n + 'PickImageTitle']: 'Válaszd ki a képet, vagy tölts fel újat',
            [n + 'PickJobCoverTitle']: 'Válaszd ki a hirdetés főképét, vagy tölts fel újat',
            [n + 'PickJobGalleryTitle']: 'Válaszd ki a hirdetés galéria képeit, vagy tölts fel újakat',
            [n + 'PickCancel']: 'Mégsem',
            [n + 'PromptCvSearch']: 'Keress nekem állásokat az önéletrajzom alapján, amit feltöltöttem',
            [n + 'PromptSetProfilePicture']: 'Állítsd be profilképnek ezt a képemet',
            [n + 'PromptJobCover']: 'Ezt a képet állítsd be a hirdetés főképének.',
            [n + 'PromptJobGallery']: 'Ezeket a képeket állítsd be a hirdetés galéria képeinek.',
            [n + 'PromptApplied']: 'Kitöltöttem az adatokat és jelentkeztem az állásra. Az adataimat már elmentette a rendszer. A továbbiakban, más állásokra már automatikusan fogod tudni küldeni a jelentkezéseimet.',

            [n + 'FloatingTitle']: agentName,
            [n + 'FloatingOpen']: 'Chat: ' + agentName,
            [n + 'FloatingTuck']: 'Félretolás',
            [n + 'FloatingExpand']: 'Nagyobb méret',
            [n + 'FloatingShrink']: 'Kisebb méret',
            [n + 'FloatingMinimize']: 'Összecsukás',
            [n + 'FloatingLoading']: 'Beszélgetés betöltése…',
            [n + 'FloatingNewChat']: 'Új beszélgetés',
            [n + 'FloatingOlderChats']: 'Korábbi beszélgetéseim',
            [n + 'FloatingDelete']: 'Beszélgetés törlése',
            [n + 'FloatingUntitled']: 'Névtelen beszélgetés',
            [n + 'FloatingNoChats']: 'Még nincs beszélgetésed',
            [n + 'FloatingIntro']: 'Szia! Én ' + agentName + ' vagyok, a VLM munkatársa. Miben segíthetek?',
            [n + 'FloatingIntroVideoButton']: 'Bemutató videó',
            [n + 'IntroVideoTitle']: agentName + ' bemutatkozik',
            [n + 'IntroVideoClose']: 'Bezárás',

            // Personalized replacement for the first default quick reply, built from the user's own profession + city.
            [n + 'PersonalizedQuickReply']: ({ profession, city } = {}) => {

                const cityOn = city === 'Budapest' ? 'Budapesten' : city

                return {
                    label: profession + ' állások' + ((cityOn === city) ? ', ' : ' ') + cityOn,
                    action: 'prompt',
                    value: 'Keress ' + String(profession || '').toLowerCase() + ' állásokat ' + ((cityOn === city) ? cityOn + ' településen' : cityOn)
                }
            },

            [n + 'DefaultQuickReplies']: [
                { label: 'Szakács állások Budapesten', action: 'prompt', value: 'Keress szakács állásokat Budapesten' },
                { label: 'Személyre szabott keresés', action: 'flow', value: 'cv' },
                { label: 'Hirdetés feladása', action: 'prompt', value: 'Szeretnék álláshirdetést feladni' },
                { label: 'Miben tudsz segíteni?', action: 'prompt', value: 'Miben tudsz segíteni?' }
            ],

            [n + 'ApplyFillButton']: 'Kitöltöm a jelentkezést',

            [n + 'Send']: 'Küldés',
            [n + 'Insert']: 'Beszúrás',
            [n + 'Placeholder']: 'Írd le, milyen munkát keresel...',
            [n + 'ExpertViewPlaceholder']: 'Válts vissza ' + agentName + ' nézetére az üzenetküldéshez',
            [n + 'PostAsPlaceholder']: ({ role } = {}) => 'Beszúrás "' + (role || '') + '" szerepben (agent nélkül)…',

            [n + 'MainAgentName']: agentName,
            [n + 'Thinking']: 'Gondolkodás',
            [n + 'ShowMore']: '▸ több',
            [n + 'ShowLess']: '▾ kevesebb',
            [n + 'MessageSave']: 'Mentés',
            [n + 'MessageCancel']: 'Mégsem',
            [n + 'MessageEdit']: 'Szerkeszt',
            [n + 'MessageDelete']: 'Töröl',
            [n + 'MessageDeleteSubmit']: 'Törlés'
        },
        menus: {
            ...menus,
            ['user' + Ns + 'Menu']: 'Beszélgetések',
            ['myPrevious' + Ns + 'Menu']: 'Korábbi beszélgetéseim',
            ['userPrevious' + Ns + 'Menu']: 'Korábbi beszélgetések',
            ['new' + N + 'Menu']: 'Új beszélgetés',
            [ns + 'Menu']: 'Beszélgetések',
            ['deleted' + Ns + 'Menu']: 'Törölt beszélgetések',
            ['banned' + Ns + 'Menu']: 'Véglegesen törölt beszélgetések',
            ['protection' + Ns + 'Menu']: 'Védett beszélgetések',
            ['missingData' + Ns + 'Menu']: 'Hiányzó adatok',
            ['lowAuthorStatus' + Ns + 'Menu']: 'Szerző alacsony státusszal',
            ['edit' + N + 'Menu']: 'Szerkesztés',
            ['delete' + N + 'Menu']: 'Törlés',
            ['ban' + N + 'Menu']: 'Tiltás',
            ['approve' + N + 'Menu']: 'Jóváhagyás',
            ['protection' + N + 'Menu']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Menu']: 'Védettség törlése'
        },
        messages: {
            ...messages,
            ['new' + N + 'SuccessMessage']: 'Beszélgetésed rögzítettük',
            ['save' + N + 'SuccessMessage']: 'A beszélgetés mentésre került',
            ['delete' + N + 'Success']: 'A beszélgetés törölve lett',
            ['delete' + Ns + 'Success']: 'A beszélgetések törölve lettek',
            ['delete' + N + 'Question']: 'Biztosan törli az beszélgetést?',
            ['delete' + Ns + 'Question']: 'Biztosan törli az beszélgetéseket?',
            ['ban' + N + 'Success']: 'A beszélgetés véglegesen törölve lett',
            ['ban' + N + 'Question']: 'Biztos, hogy az beszélgetést véglegesen törölni akarod?',
            ['approve' + N + 'Success']: 'A beszélgetés jóvá lett hagyva',
            ['approve' + N + 'Question']: 'Biztosan jóváhagyod az beszélgetést',
            ['protection' + N + 'Success']: 'A beszélgetés védettnek jelölve',
            ['protection' + N + 'Question']: 'Biztosan védettnek jelölöd az beszélgetést?',
            ['removeProtection' + N + 'Success']: 'A védettnek jelölés törölve lett',
            ['removeProtection' + N + 'Question']: 'Biztosan törlöd a védettnek jelölést?',
            ['thereAreNo' + Ns]: 'Nincsenek beszélgetések',

            [n + 'NewDefaultError']: 'Hiba történt a beszélgetés létrehozásakor, próbálja újra',

            [n + 'ResponseFailed']: 'A válasz lekérése nem sikerült.',
            [n + 'DeleteMessageQuestion']: 'Biztosan törlöd ezt az üzenetet?',
            [n + 'DeleteMessageSuccess']: 'Az üzenet törölve lett.',
            [n + 'AttachFailed']: 'A feltöltés nem sikerült, kérlek próbáld újra.',
            [n + 'AttachWrongType']: 'nem támogatott fájltípus (kép: jpg, png, gif; dokumentum: pdf, doc, docx).',
            [n + 'AttachTooBig']: 'túl nagy a fájl (kép max. 10 MB, dokumentum max. 20 MB).'
        },
        routes: {
            ...routes
        },
        titles: {
            ...titles,
            [n + 'Title']: 'Beszélgetés',
            [ns + 'Title']: 'Beszélgetések',
            ['new' + N + 'Title']: 'Beszélgetés létrehozása',
            ['edit' + N + 'Title']: 'Beszélgetés szerkesztése',
            ['user' + Ns + 'Title']: 'Beszélgetések',
            ['userDeleted' + Ns + 'Title']: 'Törölt beszélgetések',
            ['userBanned' + Ns + 'Title']: 'Véglegesen törölt beszélgetések',
            ['my' + Ns + 'Title']: 'Beszélgetéseim',
            ['myDeleted' + Ns + 'Title']: 'Törölt beszélgetéseim',
            ['myBanned' + Ns + 'Title']: 'Véglegesen törölt beszélgetéseim',

            ['dialogDelete' + N + 'Title']: 'Beszélgetés törlése',
            ['dialogBan' + N + 'Title']: 'Beszélgetés törlése véglegesen',
            ['dialogApprove' + N + 'Title']: 'Beszélgetés jóváhagyása',
            ['dialogProtection' + N + 'Title']: 'Beszélgetés védettnek jelölése',
            ['dialogRemoveProtection' + N + 'Title']: 'Beszélgetés védettségének megszüntetése',

            ['dialogDelete' + Ns + 'Title']: 'Beszélgetések törlése',

            ['dialogDelete' + N + 'MessageTitle']: 'Üzenet törlése',

            ['statusBanned' + N + 'Title']: 'Véglegesen törölt',
            ['statusDeleted' + N + 'Title']: 'Törölt',
            ['statusAuthorDeleted' + N + 'Title']: 'Szerző törölve',
            ['statusMissingData' + N + 'Title']: 'Hiányzó adatok',
            ['statusApproved' + N + 'Title']: 'Jóváhagyott',
            ['statusFeatured' + N + 'Title']: 'Védett',
            ['statusCreated' + N + 'Title']: 'Létrehozva',

            ['banned' + Ns + 'Title']: 'Véglegesen törölt beszélgetések',
            ['deleted' + Ns + 'Title']: 'Törölt beszélgetések',
            ['missingData' + Ns + 'Title']: 'Hiányzó adatok',
            ['protected' + Ns + 'Title']: 'Védett beszélgetések',
            ['lowAuthorStatus' + Ns + 'Title']: 'Szerző alacsony státusszal',

            ['select' + Ns]: 'Beszélgetések kiválasztása',
            ['select' + N]: 'Beszélgetés kiválasztása'

        }
    }
}
